// carousel driven by Core
/* global mzCarousel */

import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { get360Data, goToTop, getLoading, setTabsNextAndPrevButtons, setCursorWaiting, getBaseUrl } from '../../../utils';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import Button from '../../1_Atoms/Button/Button';
import { Svg } from '../../1_Atoms/Svg/Svg';
import CollapseLegal from '../../2_Molecules/Collapse/CollapseLegal';
import ColourCard from '../../2_Molecules/ColourCard/ColourCard';
import ThreeSixtyContainer from '../../3_Organisms/360Container/360Container';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import PackageCard from '../../2_Molecules/PackageCard/PackageCard';

export const Connectivity = ({ ...props }) => {
    const [loading, setLoading] = useState(true);
    const [is360Loading, setIs360Loading] = useState(true);
    const summaryCalculator = window.summaryCalculator;
    const { year, carline, trim, model, packageCode } = useParams();
    const [nav, setNav] = React.useState(null);
    let extArray = null;
    const [images, setImages] = React.useState({});
    const navigate = useNavigate();
    const listRef = React.useRef();
    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalConnectivity));
    const [legalModalOpen, setLegalModalOpen] = React.useState(false);
    const [connectModalOpen, setConnectModalOpen] = React.useState(false);
    const [carouselInit, setCarouselInit] = React.useState(false);
    const { t, i18n } = useTranslation(['connectivity', 'general']);
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);
    const [selectedConnectedVehicleIndex, setSelectedConnectedVehicleIndex] = React.useState(summaryCalculator.SelectedConnectedVehicleIndex);    
    const [connectivityPackage, setConnectivityPackage] = React.useState(null);    

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);
    
	const gtmHelper = new GTMHelper();
	const navHelper = new NavHelper();

    function hideShownCmsBlock() {
        let toHideBlocks = document.querySelectorAll('.mz-footer.visually-shown');
        if (toHideBlocks) {
            toHideBlocks.forEach(function (e) {
                e.classList.remove('visually-shown');
                e.classList.add('visually-hidden');
            });
        }
    }

    hideShownCmsBlock();

    summaryCalculator.CurrentStep = 5;
    

    React.useEffect(() => {
		async function executeTasks() {
            if (!summaryCalculator.isDataLoaded()) {
                await summaryCalculator.loadVehicleData(year, carline, trim, model, packageCode);

                if (JSON.parse(sessionStorage.getItem(Constants.HasFinancialProviderError)) === true) {
                    const vehiclePageUri = `/${decodeURI(window.location.search)}`;
                    navigate(vehiclePageUri)
                }

                setLoading(false);
            } else {
                setLoading(false);
            }

            if (!loading) {
                if (nav === null) {
                    const toRender = navHelper.getNavContent(t);
                    setNav(toRender);                    
                }

                if(summaryCalculator.Packages && !connectivityPackage) {
                    setConnectivityPackage(summaryCalculator.Packages.connected_services[0]);
                }
            }

            if (listRef.current) {
                window.removeEventListener('resize', setListMaxHeight);
                window.addEventListener('resize', setListMaxHeight);
                setListMaxHeight();
            }
           
        }

        executeTasks();
    }, [loading, nav, connectivityPackage]);

    function getConnectivityImagePath() {
        const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;
        //return `https://preprod.mazda.ca/globalassets/mazda-canada/discover-mazda/innovation/mymazdaapp/4.1_c44_remotevehiclestart_nobackground_en.png`
        
        return `${imagePath}${connectivityPackage.image_folder}hero_section_bnp${connectivityPackage.image_extension}`
    }

    function getModalImagePath(carousel) {
        const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;
        
        return `${imagePath}${connectivityPackage.image_folder}${carousel.image}`
    }

    function nextStep() {
        goToTop();
        navigate(`/${year}/${carline}/${trim}/${model}/${packageCode}/accessories${decodeURI(window.location.search)}`)
		gtmHelper.setGTM({'action':'Next Step'}, true , false);
    }

    function setListMaxHeight() {
        if (listRef.current && typeof(mzFunc) === 'object'){
            if (window.innerWidth < 1200) {
                listRef.current.style.height = 'auto';
            } else {
                const baseTarget= document.querySelector('.App-container .mz-connectivity-page');
                const contentHeight = baseTarget.querySelector('.mz-connectivity-page__title').clientHeight + baseTarget.querySelector('.mz-connectivity-page__content').clientHeight;
                const visibleHeight = window.innerHeight - baseTarget.querySelector('.mz-pricing').clientHeight - document.querySelector('.mz-menu').clientHeight - baseTarget.querySelector('nav').clientHeight - document.querySelector('.mz-alert--permanent')?.clientHeight;
                if(contentHeight > visibleHeight){
                    listRef.current.style.height = (window.innerHeight +150)+'px';
                }else{
                    listRef.current.style.height = 'auto';
                }
            }
		}

	}

    function handleShowFinanceClick(value) {
        setShowFinancePrice(value);
    }

    async function handleSelectedConnectedVehiclePackage(index) {
        setCursorWaiting(true);

        await summaryCalculator.setSelectedConnectedVehicleIndex(index);

        setSelectedConnectedVehicleIndex(index);
		gtmHelper.setGTM({'action':'Add Connected Vehicle Package', 'package': summaryCalculator.SelectedConnectedVehiclePackage.name}, false, false);

        setCursorWaiting(false);
    }

    async function handleRemoveConnectedVehiclelPackage(index) {
        setCursorWaiting(true);

		gtmHelper.setGTM({'action':'Remove Connected Vehicle Package', 'package': summaryCalculator.SelectedConnectedVehiclePackage.name}, true, false);

        await summaryCalculator.setSelectedConnectedVehicleIndex(null);

        setSelectedConnectedVehicleIndex(null);

        setCursorWaiting(false);
    }

	window.addEventListener('resize', setListMaxHeight);

    function setCarousel(){
        if(carouselInit){
            return `<div class="mz-container"  style="width:100%;">
                        <div class="mz-full-width w-100">
                            <div class="mz-carousel-wrapper">
                                <div data-mz-autoplay="false" data-mz-autoplay-timer="3000" data-mz-infinite-loop="true" data-mz-hide-pips="false" data-mz-carousel-theme="contain" data-mz-center="undefined" class="mz-carousel glide  mz-carousel--contain mz-carousel--light">
                                    <div class="glide__bullets slider__bullets" data-glide-el="controls[nav]">
                                        ${setBullets()}
                                    </div>
                                    <div class="glide__track" data-glide-el="track">
                                        <ul class="glide__slides">
                                            ${setSlides()}
                                        </ul>
                                    </div>
                                    <div class="glide__arrows" data-glide-el="controls">
                                        <button class="mz-btn mz-btn--carousel mz-btn--black glide__arrow glide__arrow--right" data-glide-dir=">">
                                            <span><i class="mz-svg mz-svg--grey mz-svg-chevroncarousel"></i></span>
                                        </button>
                                        <button class="mz-btn mz-btn--carousel mz-btn--black glide__arrow glide__arrow--left" data-glide-dir="<">
                                            <span><i class="mz-svg mz-svg--grey mz-svg--rotate180 mz-svg-chevroncarousel"></i></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`
        }
    }

    function setBullets(){
        let slideContent='';
        if(connectivityPackage) {
            connectivityPackage.carousel.map((carousel, index) => {
                slideContent +=`<button class="slider__bullet glide__bullet" data-glide-dir="=${index}"></button>`;
            });
        }

        return slideContent;
    }

    function setSlides(){
        let slideContent='';
        if(connectivityPackage) {
            connectivityPackage.carousel.map((carousel, index) => {
                slideContent +=`<li class="glide__slide mz-image" data-mz-slide-nth="${index}">${set5050(carousel)}</li>`;
            });
        }

        return slideContent;
    }
    function set5050(carousel){
        return `<div class="mz-5050 mz-5050--image-right">
                    <div class="mz-container unconstrained mz-5050-container full-width no-gutter-between-cols">
                        <div class="mz-5050-left mz-5050-content mz-bg--f5f5f5">
                            <div class="mz-5050-text-wrapper text--left">
                                ${carousel.content}
                            </div>
                        </div>
                        <div class="mz-5050-right mz-5050-content mz-bg--f5f5f5">
                            <div class="mz-image mz-5050-image">
                                <img src="${getModalImagePath(carousel)}"></img>
                            </div>
                        </div>
                       
                    
                    </div>
                </div>`;
    }

    return (
        <>
        {
            !summaryCalculator.isDataLoaded() ? getLoading(loading, t) : null
        }
        <div className="mz-connectivity-page mz-top-nav-spacing grid-no-gutter-sm"  ref={listRef}>
            <Nav nav={nav} />
            <h5 className="mz-connectivity-page__title">{t("connectivity:title")}</h5>
            <div className="mz-full-width mz-connectivity-page__content mz-container-flex">
                         
                <div className="mz-connectivity-page__content-left">
                    {connectivityPackage &&
                    <div className="mz-connectivity-page__content-left-container">
                        <div className="mz-connectivity-page__content-left-container__content-left">
                            <img src={getConnectivityImagePath()} alt="img" />
                        </div>
                        <div className="mz-connectivity-page__content-left-container__content-right">
                            {ReactHtmlParser(connectivityPackage.description)}

                            <a href="" className="mz-link" onClick={ (e)=>{
                                e.preventDefault();
                                setConnectModalOpen(true);
                                //mzCarousel.init();
                                if(!carouselInit){
                                    
                                   // window.setTimeout(()=>{
                                        setCarouselInit(true)
                                        mzCarousel.init();
                                        
                                    //}, 1000)
                                   
                                }
                            }}>{connectivityPackage.carousel_cta_text}</a>
                        </div>
                    </div>}
                </div>
                <div className="mz-connectivity-page__content-right right-container">
                    {connectivityPackage && Object.entries(connectivityPackage.subscription).map(([key, value], index) => 
                        <PackageCard Package={value} 
                            PopContent={t('best')}
                            ButStyle='mz-btn mz-btn--primary mz-btn--red package-card__button'
                            ButContent={t('general','add')}
                            Selected={summaryCalculator.SelectedConnectedVehicleIndex === index} 
                            ButSelectedContent={t('general','remove')}
                            HasCollapse={false}
                            HandleSelectedPackage={handleSelectedConnectedVehiclePackage} 
                            HandleRemovePackage={handleRemoveConnectedVehiclelPackage} 
                            Index={index} 
                            key={key} 
                            showFinancePrice={showFinancePrice} 
                            isUniversal={false} 
                            displayPriceCalculation={false} 
                            displayConnectedServicePriceCalculation={true}></PackageCard>)}
                </div>
            </div>
            

            <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$" saveLabel={t("general:save_build")}
                leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} buttonLabel={t("general:next_accessories")} summaryCalculator={summaryCalculator}
                HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} HandleShowFinanceClick={handleShowFinanceClick} setPreorderModalOpen={setPreorderModalOpen} />
            <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
            <Modal modalContent={setCarousel()} isOpen={connectModalOpen} handleClose={setConnectModalOpen} modalId='connectModal' />
            <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
            
        </div>
        </>
    )
}

export default Connectivity;